import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';

const MultiCarouselArrows = ({ next, previous, carouselState, cssBlock = "", color }) => {
    const [isDisabledLeft, setIsDisabledLeft] = useState(0);
    const [isDisabledRight, setIsDisabledRight] = useState(0);

    useEffect(() => {
        disableArrowButtons(carouselState);
    }, [carouselState]);

    const disableArrowButtons = (carouselState) => {
        const { totalItems, slidesToShow, currentSlide } = carouselState;

        if ((currentSlide + slidesToShow) == totalItems) {
            setIsDisabledLeft(false);
            setIsDisabledRight(true);
        }
        else if ((totalItems - currentSlide) == totalItems) {
            setIsDisabledLeft(true);
            setIsDisabledRight(false);
        }
        else {
            setIsDisabledLeft(false);
            setIsDisabledRight(false);
        }
    }
    return (
        carouselState.totalItems > carouselState.slidesToShow &&
        <div className={` multi-carousel-arrows ${cssBlock}__arrows`}>
            <button aria-label={translate('slider.arrow.left')} className={` multi-carousel-arrows__arrow multi-carousel-arrows__arrow--left ${cssBlock}__arrow-left`} onClick={previous} disabled={isDisabledLeft} style={{ borderColor: color }}></button>
            <button aria-label={translate('slider.arrow.right')} className={` multi-carousel-arrows__arrow multi-carousel-arrows__arrow--right ${cssBlock}__arrow-right`} onClick={next} disabled={isDisabledRight} style={{ borderColor: color }}></button>
        </div>
    );
};
export default MultiCarouselArrows;